const icons = document.querySelectorAll('.block-content-card__icon');

const observer = new IntersectionObserver(
	(entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				entry.target.classList.add('active');
				observer.unobserve(entry.target);
			}
		});
	},
	{
		rootMargin: '-37.5% 0px -37.5% 0px',
	}
);

icons.forEach((icon) => {
	const rect = icon.getBoundingClientRect();
	const viewportHeight = window.innerHeight;
	const triggerZoneTop = viewportHeight * 0.375;
	const triggerZoneBottom = viewportHeight * 0.625;

	if (
		rect.bottom <= triggerZoneTop ||
		(rect.top <= triggerZoneBottom && rect.bottom >= triggerZoneTop)
	) {
		icon.classList.add('active');
	}

	observer.observe(icon);
});
